import NoSIPSCessionDialog from "./Dialog";
import Settings from "@/settings";

import { Button, Checkbox, FormControlLabel } from "@mui/material"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { 
  INoCessionSIPSFetchData, 
  NoSIPSCessionStates 
} from "./types/noSIPSCession";
import useNoSIPSCession from "./hooks/useNoCessionSIPS";
import { Tooltip } from "@gisce/oficina-virtual-components";
import useAuth from "@/hooks/useAuth";

interface IContractNoCessionProps {
  isAtrAvailable: boolean;
  changeDialogOpen: (val: boolean) => void;
  contractName: string;
  isContactActive: boolean;
  initialDialogOpen?: boolean;
  noSIPSCession: INoCessionSIPSFetchData;
  open: boolean;
}

interface ISIPSCessionStatusProps {
  checked: boolean;
  label: string;
}

type SIPSCessionCases = {
  [key in NoSIPSCessionStates]: ISIPSCessionStatusProps;
}

const NoSIPSCession: FC<IContractNoCessionProps> = ({
  isAtrAvailable,
  changeDialogOpen,
  contractName,
  isContactActive,
  noSIPSCession,
  open
}) => {
  const { t } = useTranslation();

  const { tokenVals } = useAuth();
  const SIPSCessionCases: SIPSCessionCases = {
    "requested": { checked: false, label: t('common:text.sips_requested') },
    "active": { checked: true, label: t('common:text.sips_active') },
    "unactive": { checked: false, label: t('common:text.sips_disabled') }
  }

  const handleClose = () => {
    changeDialogOpen(false)
  };

  const {
    errors,
    isSubmitting,
    handleSubmitNoSIPSCession
  } = useNoSIPSCession({
    contractName,
    handleClose
  });

  return (
    <div>

      <NoSIPSCessionDialog
        errors={errors}
        isSubmitting={isSubmitting}
        isWaitingForSignature={noSIPSCession.waiting_for_signature}
        handleSubmitNoSIPSCession={handleSubmitNoSIPSCession}
        open={open} 
        changeDialogSipsOpen={changeDialogOpen} 
      />
      
      <div>

        <FormControlLabel
          control={
            <Checkbox
              disabled={true}
              checked={SIPSCessionCases[noSIPSCession.state].checked}
              checkedIcon={<VisibilityOff />}
              icon={<Visibility />}
            />
          }
          label={t('common:text.sips_title')}
        />

        {!Settings?.contract?.horizontalButtons &&
          <Tooltip
            title={tokenVals?.readonly &&
              t("common:text.token_readonly_tooltip")
            }
            placement="right"
            arrow
            disableFocusListener={!tokenVals?.readonly}
            disableHoverListener={!tokenVals?.readonly}
            disableTouchListener={!tokenVals?.readonly}
            slotProps={{
              popper: {
                modifiers: [{
                  name: 'offset',
                  options: {offset: [0, -5]}
                }]
              }
            }}
          >
            <span style={{ 'width': '100%' }}>
              <Button
                color={'primary'}
                variant={'text'}
                disabled={
                  (noSIPSCession.state == "requested"
                    && !noSIPSCession.waiting_for_signature)
                  || !isAtrAvailable
                  || !isContactActive
                  || tokenVals?.readonly
                }
                title={t('common:text.sips_edit_data')}
                onClick={() => changeDialogOpen(true)}
              >
                {SIPSCessionCases[noSIPSCession.state]?.label}
              </Button>
            </span>
          </Tooltip>
        }

      </div>

      { noSIPSCession.state === 'requested' &&
        <div style={{ fontSize: '12px' }}>
          <em>{t('common:text.sips_process_already')}</em>
        </div>
      }

    </div>
  );
}

export default NoSIPSCession;
